module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_003.png
// module id = 926
// module chunks = 0